import { Component } from 'react';
import { Text, View } from 'react-native';

import IconCartEmpty from '../../../assets/svg/IconCartEmpty';
import Button from '../../../elements/CommonButton';
import { ButtonType } from '../../../elements/CommonButton/CommonButton';
import { translate } from '../../../i18n';
import { getIsTW } from '../../../utils/countryInfo';
import * as navigationService from '../../../utils/navigationService';
import CheckoutItemCard from '../../CheckoutItemCard';
import FlatListWithImpression from '../../FlatListWithImpression';
import { cartContentItemProducer } from '../../FlatListWithImpression/utils';
import ReachSeriesOfHints from '../ReachSeriesOfHints';
import styles from './styles';

interface Props {
  isFocused: boolean;
  cartIds: string[];
  layoutName: string;
}

const keyExtractor = item => `${item}`;

export default class CartContent extends Component<Props> {
  static defaultProps = {
    cartIds: [],
  };

  renderHeader = () => {
    if (!getIsTW()) {
      return null;
    }

    return (
      <ReachSeriesOfHints
        style={this.props.cartIds.length ? { marginBottom: 8 } : {}}
      />
    );
  };

  renderItem = ({ item, index }: { item: string; index: number }) => {
    const { cartIds, layoutName } = this.props;
    const itemLength = cartIds.length;
    const [, vid] = item.split('-');

    return (
      <>
        <CheckoutItemCard
          index={index}
          vid={vid}
          key={cartIds[index]}
          layoutName={layoutName}
          itemLength={itemLength}
          source="atcitem"
        />
        {index < itemLength - 1 ? <View style={styles.separator} /> : null}
      </>
    );
  };

  handleGoShopping = () => {
    navigationService.reset();
  };

  render() {
    const { isFocused, cartIds, layoutName } = this.props;

    return cartIds.length ? (
      <FlatListWithImpression
        testID={'CartContentListView'}
        data={cartIds}
        dataProducer={cartContentItemProducer}
        numColumns={1}
        layoutName={layoutName}
        keyExtractor={keyExtractor}
        renderItem={this.renderItem}
        ListHeaderComponent={this.renderHeader}
        isFocused={isFocused}
        style={styles.container}
        source="atcitem"
      />
    ) : (
      <>
        {this.renderHeader()}
        <View style={styles.emptyWrapper}>
          <IconCartEmpty />
          <Text style={styles.emptyText}>{translate('cart-empty')}</Text>
          <View style={styles.goToShopBtnWrapper}>
            <Button
              style={styles.goToShopBtn}
              onPress={this.handleGoShopping}
              text={translate('goShopping')}
              buttonType={ButtonType.SECONDARY}
            />
          </View>
        </View>
      </>
    );
  }
}
